module.exports = __webpack_public_path__ + "img/1.1dc64312.png";